import React, { Component } from 'react';
// import Buttons from '../../../UI/Buttons';
// import Wrp from '../../../hoc/Wrp/Wrp';
import Icons from '../../../Icons/Icons';
import moment from 'moment';
import {getUserTimeZone } from '../../../../Utils/UserFunctions';
import $ from 'jquery';
import { isSet } from '../../../../Utils/CommonFunctions';


class Activity extends Component {
  
    componentDidMount(){
    //   console.log(this.props);
      //Task,Call,Meeting
    }
    componentDidUpdate = ()=>{
        $('.d-Activity.dropright').hover(function() {
            $(this).find('.dropdown-menu').stop(true, true).delay().fadeIn();
            $(this).find('.dropdown-menu').css({"marginLeft": "15px", "top": "-10px"});
            $('.table tbody tr th').css( {"position": "inherit" });
        }, 
    
        function() {
            $(this).find('.dropdown-menu').stop(true, true).delay().fadeOut();
            $('.table tbody tr th').css( "position", "sticky" );
        });
    }
    render () {
        const {colData,id} = this.props;
        const activityTypes = {
            'calls':{
                iconType:'Call',
                bgColor:'callBg'
            },
            'tasks':{
                iconType:'Task',
                bgColor:'taskBg'
            },
            'meetings':{
                iconType:'Meeting',
                bgColor:'meetingBg'
            }
        }
        const activityData = colData.value;
       if(Object.keys(activityData).length>0){
            const activityType  = (activityData['Activity Type']!==undefined)?activityData['Activity Type']:'';
            const CallStartTime = (activityData['Call Start Time']!==undefined)?activityData['Call Start Time']:'';
            const DueDate = (activityData['Due Date']!==undefined)?activityData['Due Date']:'';
            const From = (activityData['From']!==undefined)?activityData['From']:'';
            const Subject = (activityData['Subject']!==undefined)?activityData['Subject']:'';
            // console.log(activityTypes,activityType);
            let displayDate = null;
            if(activityType.toLowerCase()==='tasks'){
                displayDate = moment(DueDate, 'YYYY-MM-DD HH:mm:ss', true).format('YYYY-MM-DD');
            }else if(activityType.toLowerCase()==='meetings'){
                displayDate = moment(From, 'YYYY-MM-DD HH:mm:ss', true).format('YYYY-MM-DD');
            }else if(activityType.toLowerCase()==='calls'){
                displayDate = moment(CallStartTime, 'YYYY-MM-DD HH:mm:ss', true).format('YYYY-MM-DD');
            }
            const current = moment().tz(getUserTimeZone()).format('YYYY-MM-DD');
            // console.log(current,displayDate);
            const displayDateFt = displayDate;
            if(current===displayDate){
                displayDate = 'Today';
            }else{
                displayDate = moment(displayDate, 'YYYY-MM-DD', true).format('MMM Do');
            }
            return(
                <th key={"column"+id} className="crmActivity" style={{position: 'sticky'}}>   
                    <div className="message message-in">
                        <Icons iconType={activityTypes[activityType.toLowerCase()].iconType} />
                        <div className="message-body">
                        <a href="#">
                            <div className="d-Activity dropright hidden-caret">
                                <div className={`message-content ${activityTypes[activityType.toLowerCase()].bgColor}`}>
                                    <div className="content">
                                        {displayDate}
                                    </div>
                                    <ul className="dropdown-menu border">
                                        <li>
                                            <div className="dropdown-title secondary_color">{activityType+': '+Subject} </div>
                                        </li>
                                        <li></li>
                                        <li className="text-small text-wrap p-2">{DueDate}</li>
                                        <li className="text-small text-wrap p-2"> {moment(displayDateFt, 'YYYY-MM-DD', true).format('MMM Do YY')}</li> 
                                    </ul>					 
                                </div>
                            </div>
                        </a>
                    </div>
                    </div>
                    
                </th>
            );
        }else{
            return <th style={{width:'30px'}}>
                {(isSet(colData.status,'LOADED')==='LOADING')?
                    <Icons iconType='ActivityLoader' color="#00afe9" />
                :'' }
            </th>;
        }
    }
}

export default Activity;